import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: 'All',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue')
  },
  {
    path: '/asr',
    name: 'ASR',
    component: () => import(/* webpackChunkName: "ASR" */ '../views/ASR/index.vue')
  },
  {
    path: '/audio_file_to_text',
    name: 'Audio File to Text',
    component: () => import(/* webpackChunkName: "Audio File to Text" */ '../views/AudioFileToText/index.vue')
  },
  {
    path: '/setting',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "Setting" */ '../views/Setting/index.vue')
  },
  {
    path: '/setting/logs',
    name: 'Logs',
    component: () => import(/* webpackChunkName: "Logs" */ '../views/Setting/Logs/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // avoid redirect to same page
  if (to === from) {
    return
  }

  // redirect to login page if not logged in and trying to access a restricted page
  const public_pages = ['/']
  const auth_required = !public_pages.includes(to.path)
  const logged_in = store.state.auth.status
  const post_login_action_required = store.state.auth.post_login_action_required
  const page_access = store.state.auth.page_access

  if (auth_required && !logged_in) return next('/')

  if (to.path !== '/' && post_login_action_required) return next('/')

  // prevent logged in user access login page again
  if (to.path === '/' && logged_in && !post_login_action_required) return next(page_access[0])

  // redirect to first page if no page access right
  if (logged_in && !post_login_action_required && !page_access.includes('/'.concat(to.path.split('/')[1]))) return next(page_access[0])

  next()
})

export default router
